import { render, staticRenderFns } from "./quote-table.vue?vue&type=template&id=1d47a0f7&scoped=true&"
import script from "./quote-table.vue?vue&type=script&lang=js&"
export * from "./quote-table.vue?vue&type=script&lang=js&"
import style0 from "./quote-table.vue?vue&type=style&index=0&id=1d47a0f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47a0f7",
  null
  
)

export default component.exports